import { render, staticRenderFns } from "./AdditionalInfoModal.vue?vue&type=template&id=e9487528&scoped=true&"
import script from "./AdditionalInfoModal.vue?vue&type=script&lang=js&"
export * from "./AdditionalInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInfoModal.vue?vue&type=style&index=0&id=e9487528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9487528",
  null
  
)

export default component.exports